import "../scss/screen.scss";
import "flatpickr/dist/flatpickr.min.css";
import "./plugins/navigator-saywho";

import UIkit from "uikit/dist/js/uikit-core";
import "./misc/utm";
import "./misc/date";
import "./misc/share";

// Load Lottie animation library - this is for the animated illustration card graphics
import lottie from "lottie-web";
window.lottie = lottie; // Make Lottie globally available

// ACF Gutenberg block scripts for 2024 refresh
import "./misc/appsBrowser"; // toggling tabbed content
import "./misc/solutionsAccordion"; // accordion content block
import "./misc/personCards";
import "./misc/productNavigation";
import "./misc/mainNavBlur";
import "./misc/statsCounter"; // stats module counting animations
import "./misc/heroPatternTransitions"; // hero slider animations
import "./misc/heroPattern2025"; // hero block 2025 animations
import "./misc/lottieAnimations"; // lottie animations on homepage
import "./misc/solutionsHero"; // solutions hero animations
import "./misc/solutionsRadio"; // solutions radio animations
import "./misc/solutionsScrollCarousel"; // solutions scroll carousel animations
import "./misc/solutionsScrollAccordion"; // solutions scroll accordion animations
import "./misc/eventsArchive"; // events archive hero CTA visibility + nav scrollspy

import "./misc/marketoScripts";
import "./misc/ctaTracking";
import heroTyping from "./misc/heroTyping";
import "./misc/blogPaginationTitles"; // Handles pagination titles on the blog
import "./misc/js-error-reporter"; // Handles JS error reporting (CORS)
import "./misc/reveal-on-scroll"; // Handles reveal on scroll animations

// Only on reload/back-forward: neutralize restored scroll so stacked pinned blocks don't init mid-page; never move a user who already scrolled
if (document.querySelector(".solutionScrollCarousel")) {
	const navEntry = performance.getEntriesByType("navigation")[0];
	const isRestoredNavigation = Boolean(navEntry && navEntry.type !== "navigate");
	if (isRestoredNavigation) {
		let userScrolled = false;
		const markUserScroll = () => {
			userScrolled = true;
		};
		["wheel", "touchmove", "pointerdown", "keydown"].forEach((type) => window.addEventListener(type, markUserScroll, { passive: true, once: true, capture: true }));
		window.scrollTo(0, 0);
		window.addEventListener(
			"load",
			() => {
				if (!userScrolled) {
					window.scrollTo(0, 0);
				}
			},
			{ once: true }
		);
	}
}

window.UIkit = UIkit;
// Icons from assets/src/dr-icons that never reached the built uikit-icons bundle (stale custom set).
window.UIkit.icon.add({
	x: '<svg width="20" height="20" viewBox="0 0 20 20"><path d="m15.08,2.1h2.68l-5.89,6.71,6.88,9.1h-5.4l-4.23-5.53-4.84,5.53H1.59l6.24-7.18L1.24,2.1h5.54l3.82,5.05,4.48-5.05Zm-.94,14.23h1.48L6,3.61h-1.6l9.73,12.71h0Z"/></svg>',
	"play-circle-small":
		'<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="none"><path fill="#FF5600" fill-rule="evenodd" d="M10.999 1.833c-5.06 0-9.167 4.107-9.167 9.167s4.107 9.167 9.167 9.167S20.165 16.06 20.165 11 16.06 1.833 11 1.833ZM9.165 15.125l5.5-4.125-5.5-4.125v8.25ZM3.665 11c0 4.042 3.291 7.333 7.334 7.333 4.042 0 7.333-3.29 7.333-7.333s-3.29-7.333-7.333-7.333S3.665 6.957 3.665 11Z" clip-rule="evenodd"/></svg>',
	"play-circle-big":
		'<svg width="68" height="68" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="34" cy="33.879" r="33.625" fill="#FFFFFF" /><path fill-rule="evenodd" clip-rule="evenodd" d="M46.904 33.427a1.12 1.12 0 0 1 0 1.939L28.217 46.22a1.12 1.12 0 0 1-1.684-.969v-21.71a1.12 1.12 0 0 1 1.684-.968l18.687 10.854Z" fill="#2D3C85"/></svg>',
	checkmark:
		'<svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" fill="none"><path fill="#1A59D2" d="M12.75 22c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10Z" opacity=".2"/><path fill="#1044A8" d="M10.922 14.162 8.562 12a.996.996 0 1 0-1.41 1.41l3.07 2.872c.39.39 1.02.39 1.41 0l6.595-6.37a.996.996 0 1 0-1.41-1.41l-5.895 5.66Z"/></svg>',
	launch:
		'<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="none" d="M0 0h24v24H0V0z"/><path d="M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"/></svg>',
	pdf: '<svg width="24" height="26" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path d="M0 1h24v24H0z"/><path d="M20 3H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 14H8V5h12v12zM4 7H2v14c0 1.1.9 2 2 2h14v-2H4V7zm12 6v-3c0-.55-.45-1-1-1h-2v5h2c.55 0 1-.45 1-1zm-2-3h1v3h-1v-3zm4 2h1v-1h-1v-1h1V9h-2v5h1v-2zm-8 0h1c.55 0 1-.45 1-1v-1c0-.55-.45-1-1-1H9v5h1v-2zm0-2h1v1h-1v-1z" fill="#2D8FE2"/></g></svg>',
});

let util = UIkit.util;
window.$ = util.$;
let body = $("body");

// loads the Icon plugin
import(/* webpackChunkName: "icons" */ "uikit/dist/js/uikit-icons").then((module) => {
	UIkit.use(module.default);
});

const config = {
	// <template>: <body class regex>
	"blog-filter": "(post-type-archive-blog|tax-category_blog)",
	newsroom: "category-newsroom",
};

const parts_config = {
	// <part>: <class name to trigger>
	lightbox: "[uk-lightbox]",
	filter: "[uk-filter]",
	slider: "[uk-slider]",
	"content-with-video-animation": ".dr-sticky-scroll",
	"video-with-steps": ".js-videoSlider",
	"content-slider": ".dr-content-slider",
	"card-grid": ".js-card-filter",
	"trust-radius-widget": ".trustradius-tqw",
	"tabs-switcher": ".js-tabs-switcher",
	"sticky-tabs": ".js-sticky-tabs",
	"table-of-content": ".js-table-of-content",
	loadmore: ".js-load-more",
	swiper: "[swiper]",
	form: ".dr-form",
	timeline: ".dr-timeline",
	"media-text-video-autoplay": ".wp-block-media-text video",
	countup: ".js-countup-block",
	"code-snippet": ".wp-block-code",
	"image-with-caption": ".editor-content",
	"archive-filter": "#search-results",
	"modal-1": ".modal-1",
	"dr-code-snippet": ".dr-code-snippet",
	"dr-aws-form": ".dr-aws-form",
	"two-columns-lottie": ".twoColumnsLottie",
	"copy-inline": ".copy-inline-container",
	"careers-hero": ".careersHero",
	"careers-we-work": ".careersWeWork",
	"careers-benefits": ".careersBenefits",
	"careers-locations": ".careersLocations",
	"events-scroll": ".eventsArchiveHero",
	"careers-photos": ".careersPhotos",
	"careers-filter": "#careers-search",
	"title-with-pattern-bar": ".titleWithPatternBar",
	"solutions-data": ".solutionsData",
	"audio-player": ".dr-audioPlayer",
};

for (let name in config) {
	let re = new RegExp(config[name]);
	if (re.test(body.classList.toString())) {
		import(/* webpackChunkName: "templates/[request]" */ "./templates/" + `${name}`)
			.then((module) => {
				module.default();
			})
			.catch((err) => {
				console.log(err);
			});
		break;
	}
}

for (let name in parts_config) {
	if (document.querySelector(parts_config[name])) {
		import(/* webpackChunkName: "parts/[request]" */ "./parts/" + `${name}`)
			.then((module) => {
				module.default();
			})
			.catch((err) => {
				console.log(err);
			});
	}
}

function loadWistia() {
	// Load Wistia script if the Wistia global object is not defined
	// and the script hasn't been added to the page yet.
	if (typeof Wistia === "undefined" && !document.querySelector('script[src="https://fast.wistia.com/assets/external/E-v1.js"]')) {
		let script = document.createElement("script");
		script.src = "https://fast.wistia.com/assets/external/E-v1.js";
		script.async = true;
		document.body.appendChild(script);
	}
}
document.addEventListener("DOMContentLoaded", function () {
	let wistiaElements = document.querySelectorAll(".js-wistia-trigger");
	if (wistiaElements.length > 0) {
		window._wq = window._wq || [];
		wistiaElements.forEach((video) => {
			video.addEventListener("click", (el) => {
				// Dynamically load Wistia JavaScript API
				// Play video after API has loaded
				let videoId = "";
				el.currentTarget.parentElement.classList.forEach((className) => {
					if (className.startsWith("wistia_async_")) {
						videoId = className.slice().slice(13);
						_wq.push({
							id: videoId,
							onReady: function (video) {
								if (video.popover != undefined) {
									video.popover.show();
								}
								video.play();
							},
						});
					}
				});
				loadWistia();
			});
		});
	}

	// Auto-click Wistia trigger on customer-template pages
	if (document.body.classList.contains("casestudy-template") || document.body.classList.contains("casestudy-template-default")) {
		const wistiaEmbedForAutoClick = document.querySelector(".wistia_embed[class*='wistia_async_']");
		if (wistiaEmbedForAutoClick) {
			let videoId = "";
			wistiaEmbedForAutoClick.classList.forEach((className) => {
				if (className.startsWith("wistia_async_")) {
					videoId = className.substring("wistia_async_".length);
				}
			});

			if (videoId) {
				window._wq = window._wq || [];
				loadWistia();

				_wq.push({
					id: videoId,
					onReady: function (wistiaVideoPlayer) {
						if (wistiaVideoPlayer && wistiaVideoPlayer.popover && typeof wistiaVideoPlayer.popover.show === "function") {
							wistiaVideoPlayer.popover.show();
						}
						if (wistiaVideoPlayer && typeof wistiaVideoPlayer.play === "function") {
							wistiaVideoPlayer.play();
						}
					},
				});
			}
		}
	}

	// Initialize Wistia player without autoplay on webinar pages
	if (document.body.classList.contains("single-webinar") || document.body.classList.contains("single-resource")) {
		const wistiaEmbedForAutoClick = document.querySelector(".wistia_embed[class*='wistia_async_']");
		if (wistiaEmbedForAutoClick) {
			const swatch = wistiaEmbedForAutoClick.querySelector(".wistia_swatch");
			if (swatch) {
				swatch.style.display = "none";
			}
			let videoId = "";
			wistiaEmbedForAutoClick.classList.forEach((className) => {
				if (className.startsWith("wistia_async_")) {
					videoId = className.substring("wistia_async_".length);
				}
			});

			if (videoId) {
				window._wq = window._wq || [];
				loadWistia();

				_wq.push({
					id: videoId,
					onReady: function (wistiaVideoPlayer) {
						if (wistiaVideoPlayer && typeof wistiaVideoPlayer.pause === "function") {
							wistiaVideoPlayer.pause();
						}
						// We just need to initialize the player without autoplay
					},
				});
			}
		}
	}

	if (
		// load if we have content with video animation block
		document.getElementsByClassName("dr-sticky-scroll").length ||
		// if we have direct link to video
		(window.location.search && window.location.search.includes("wvideo")) ||
		// if we have autoplay videos
		document.getElementsByClassName("autoPlay=true").length
	) {
		loadWistia();
	}

	if (document.body.classList.contains("home")) {
		heroTyping();
	}
});

// Add JP-specific class to <body> if "/jp/" is in the URL
document.addEventListener("DOMContentLoaded", function () {
	if (window.location.href.includes("/jp/")) {
		document.body.classList.add("jp-locale");
	}
});
